
<template>
  <div class="">
    <div class="employee-attendance-wrapper">

      <div class="clearfix row pb-2 mb-2 no-margin">
        <div class="col-sm-4 pl-0 leave-search-mobile">
          <div class="custom-search">
            <b-input-group class="mb-0 attendance-search">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
            </b-input-group>
          </div>
        </div>
        <div class="col-sm-8 attendance-button-wrapper">
          <div class="">
            <div class="row leave-year-month-mobile">
              <div class="col-sm-4"></div>
              <div class="col-sm-3">
                <b-input-group class="mb-2">
                  <b-input-group-prepend is-text>
                    Year
                  </b-input-group-prepend>
                  <b-form-select id="year" name="year" v-model="year" :options="years" @change="reloadData()"></b-form-select>
                </b-input-group>
              </div>
              <div class="col-sm-3">
                <b-input-group class="mb-2">
                  <b-input-group-prepend is-text>
                    Month
                  </b-input-group-prepend>
                  <b-form-select id="month" name="month" v-model="month" :options="months" @change="reloadData()"></b-form-select>
                </b-input-group>
              </div>
              <div class="col-sm-2 d-flex justify-content-start align-items-center">
                <a class="ml-1 cursor-pointer dowload-button" :href="$api_url+'/front/employee/attendance/month?approver=1&export_flg=1&month='+this.month+'&year='+this.year"><b-icon class="cursor-pointer" icon="cloud-download" font-scale="2" ></b-icon>
                </a>
              </div>

            </div>
          </div>


        </div>

      </div>
      <div class="row py-2 mb-3">

        <div class="col-sm-2 company-form-box-title">
          Attendance Log
        </div>

        <div class="col-sm-10 attendance-button-wrapper">
        </div>
      </div>

      <b-modal id="bv-modal-import-attendance" scrollable  hide-footer title="Import Attendance">

        <b-overlay :show="showoverlay" rounded="sm" class="">

          <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
          <div v-if='errormsg'>
            <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
            <ul class="list-group ">
              <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
            </ul>
          </div>
        </b-overlay>
      </b-modal>

      <div class="row justify-content-center no-margin">
        <div class="col-sm-12  px-0 table-parent">

        </div>
        <div class="col-sm-12  px-0 table-parent">
          <table class="table attendance-table table-sticky border" style="table-layout:fixed;"> <!-- Mustafijur: 20-05-2026 -->
            <thead class="table-head" style="">
            <tr>
              <td class="employee" > Employee</td>
              <td class="" align="center" v-for="(day_details , n) in week_days_header" :key="n" v-bind:style="{ backgroundColor: head_color[day_details.day] }">
                <div :title="day_details.title" v-b-tooltip>{{n}}</div>
              </td>
            </tr>
            </thead>
            <tbody class="table-body">
            <tr v-for="(attendance, temp) in paginatedData" :key="attendance.id">
              <td class="name">{{ attendance.name }}</td>

              <td v-for="(day_details, d) in week_days_header" :key="d" align="center">
                <template v-if="month == this_month && this_year == year && parseInt(d) > parseInt(today_index)">
                  <template v-if="getAttendanceCell(attendance, d, day_details).type === 'leave'">
                    <template v-if="getAttendanceCell(attendance, d, day_details).row && getAttendanceCell(attendance, d, day_details).row.leave_data">
                      <div :id="'fcd' + getAttendanceCell(attendance, d, day_details).row.leave_data.id">
                        <div
                            :class="getCellClass(getAttendanceCell(attendance, d, day_details))"
                            :style="getCellStyle(getAttendanceCell(attendance, d, day_details), day_details)"
                        ></div>

                        <b-tooltip
                            v-if="getAttendanceCell(attendance, d, day_details).tooltip != ''"
                            :target="'fcd' + getAttendanceCell(attendance, d, day_details).row.leave_data.id"
                            triggers="hover"
                        >
                          {{ getAttendanceCell(attendance, d, day_details).tooltip }}
                        </b-tooltip>
                      </div>
                    </template>
                  </template>

                  <template v-else>
                    <b-icon icon="dash" variant="info" font-scale="2"></b-icon>
                  </template>
                </template>

                <template v-else>
                  <div :class="{ today: parseInt(d) == parseInt(today_index) }">
                    <template v-if="getAttendanceCell(attendance, d, day_details).row && getAttendanceCell(attendance, d, day_details).row.id">
                      <div :id="'c' + getAttendanceCell(attendance, d, day_details).row.id">
                        <div
                            :class="getCellClass(getAttendanceCell(attendance, d, day_details))"
                            :style="getCellStyle(getAttendanceCell(attendance, d, day_details), day_details)"
                            @click="handleCellClick(getAttendanceCell(attendance, d, day_details), attendance, day_details)"
                        >
                          <span v-if="getAttendanceCell(attendance, d, day_details).type === 'resolve_absent'" class="cross-wrapper"></span>
                        </div>

                        <b-tooltip
                            v-if="getAttendanceCell(attendance, d, day_details).tooltip != ''"
                            :target="'c' + getAttendanceCell(attendance, d, day_details).row.id"
                            triggers="hover"
                        >
                          {{ getAttendanceCell(attendance, d, day_details).tooltip }}
                        </b-tooltip>
                      </div>
                    </template>

                    <template v-else-if="getAttendanceCell(attendance, d, day_details).type === 'leave' && getAttendanceCell(attendance, d, day_details).row && getAttendanceCell(attendance, d, day_details).row.leave_data">
                      <div :id="'cd' + getAttendanceCell(attendance, d, day_details).row.leave_data.id">
                        <div
                            :class="getCellClass(getAttendanceCell(attendance, d, day_details))"
                            :style="getCellStyle(getAttendanceCell(attendance, d, day_details), day_details)"
                        ></div>

                        <b-tooltip
                            v-if="getAttendanceCell(attendance, d, day_details).tooltip != ''"
                            :target="'cd' + getAttendanceCell(attendance, d, day_details).row.leave_data.id"
                            triggers="hover"
                        >
                          {{ getAttendanceCell(attendance, d, day_details).tooltip }}
                        </b-tooltip>
                      </div>
                    </template>

                    <template v-else>
                      <div
                          :class="getCellClass(getAttendanceCell(attendance, d, day_details))"
                          :style="getCellStyle(getAttendanceCell(attendance, d, day_details), day_details)"
                          @click="handleCellClick(getAttendanceCell(attendance, d, day_details), attendance, day_details)"
                      >
                        <span v-if="getAttendanceCell(attendance, d, day_details).type === 'resolve_absent'" class="cross-wrapper"></span>
                      </div>
                    </template>
                  </div>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
          <div v-else class="px-3">
            <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
              <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                <ul class="pagination b-pagination float-left mb-0 mt-1">
                  <li class="page-item disabled m-2">View</li>
                  <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                  <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                </ul>
                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
              </div>

            </div>
          </div>
        </div>
        <div class="col-sm-12  px-0 legend-wrapper">
          <div class="attendance-log">
            <div class="stats-info-wrapper legend mt-3">
              <div class="row col-sm-12 trz_borders px-4 mb-0">
                <div class="col-sm-3 py-3"><div class="mark current"></div><div class="text">Current</div></div>
                <div class="col-sm-3 py-3"><div class="mark absent"></div><div class="text">Absent</div></div>
                <div class="col-sm-3 py-3"><div class="mark present"></div><div class="text">Present</div></div>
                <div class="col-sm-3 py-3"><div class="mark" v-bind:style="{ backgroundColor: holiday_color_code }"></div><div class="text">Holiday</div></div>
                <div class="col-sm-3 py-3"><div class="mark"v-bind:style="{ backgroundColor: weekend_color_code }"></div><div class="text">Weekend</div></div>
                <div class="col-sm-3 py-3"><div class="mark late"></div><div class="text">Late</div></div>
                <div class="col-sm-3 py-3"><div class="mark late"></div><div class="text">Left Early</div></div>
                <template v-for="leavetype in leavetypes">
                  <div class="col-sm-3 py-3" >
                    <div class="mark" v-bind:style="'background:'+leavetype.color_code"></div><div class="text">{{leavetype.title}}</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>


      <b-modal id="activity_logModal" size="xl" scrollable  hide-footer title="Attendence Info">
        <div class="row no-margin">
          <div class="col-md-6">
            <div class="card punch-status">
              <div class="card-body">
                <h5 class="card-title">Timesheet <small class="text-muted">{{attendances_date}}</small></h5>
                <div class="punch-det">
                  <h6>Punch In at</h6>
                  <p>{{check_in}}</p>
                </div>
                <div class="punch-info">
                  <div class="punch-hours">
                    <span>{{work_time}} hrs</span>
                  </div>
                </div>
                <div class="punch-det">
                  <h6>Punch Out at</h6>
                  <p>{{checkout}}</p>
                </div>
                <div class="statistics">
                  <div class="row">
                    <div class="col-md-6 col-6 text-center">
                      <div class="stats-box">
                        <p>Break</p>
                        <h6>{{break_time}} hrs</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card recent-activity">
              <div class="card-body">
                <h5 class="card-title">Activity</h5>
                <ul class="res-activity-list" v-if="activity_log">
                  <li v-for="(activity, index) in activity_log.split(',')">
                    <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                    <p class="mb-0" v-else>Punch Out at</p>
                    <p class="res-activity-time">
                      <i class="far fa-clock"></i>
                      {{formateMe(activity) }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal id="edit_Modal" size="l" scrollable  hide-footer title="Attendence Info">
        <div class="card border-0 no-shadow">
          <div class="card-body pt-0">
            <h5 class="card-title">Timesheet <small class="text-muted">{{edit_date}}</small></h5>
          </div>
        </div>
        <div class="row no-margin">
          <div class="col-md-4 pr-2">
            <div class="btn btn-primary cursor-pointer w-100" @click="addLeave()">Add Leave</div>
          </div>
          <div class="col-md-4 pl-2">
            <div class="btn btn-primary cursor-pointer w-100" @click="workedOffsite(0)">Worked Offsite</div>
          </div>
          <div class="col-md-4 pl-2">
            <div class="btn btn-primary cursor-pointer w-100" @click="workedOffsite(1)">Resolve</div>
          </div>
        </div>
      </b-modal>
      <b-modal id="addLeave_Modal" size="xl" scrollable  hide-footer title="Leave Details">
        <employee-leave-details v-if="this.employee_id > 0"  :attendances_date="this.edit_date" v-on:childToParent="reloadData"></employee-leave-details>
      </b-modal>
      <b-modal id="workedOffsite_Modal" size="xl" scrollable  hide-footer :title="'Resolve : ' + edit_date">
        <worked-offsite v-if="this.employee_id > 0"   :attendances_date="this.edit_date" :resolve_flg="resolve_flg" v-on:childToParent="reloadData"></worked-offsite>
      </b-modal>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default{

  mounted() {
    if(this.check_ce == 1)
    {
      if(this.ce_flg == 1)
        this.ce = true;
      else
        this.ce = false;


    }
  },
  props: [ 'flg' , 'moment'],
  components: { },
  data(){
    const now = new Date();
    return {

      flag : this.flg,
      empfile : null,
      has_file : false,
      upload_url : '',
      process_url : '',

      attendances:[],
      week_days_header:[],
      head_color : {weekend : '#aaaaaa' , holiday : '#aaaaaa'},
      search:'',
      length: 50,
      temp_length: 50,
      length_options: [],
      pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
      ce : true,
      today_index : 0,
      grace_time_late_check_in : 0,
      grace_time_early_checkout : 0,

      blankmsg : 'Fetching data..',

      can_download_template : true,


      attendances_date : null,

      check_in : null,
      checkout : null,
      work_time : 0,
      break_time : 0,
      over_time : 0,
      activity_log : null,

      edit_date : null,
      employee_id : 0,
      showoverlay:false,

      resolve_flg : 0,

      this_month: now.getMonth() + 1,
      month: now.getMonth() + 1,
      year: now.getFullYear(),
      this_year:now.getFullYear(),
      f_y:'',
      errormsg:[],
      leavetypes:[],
      months: [
        { text: 'January', value: '1' },
        { text: 'February', value: '2' },
        { text: 'March', value: '3' },
        { text: 'April', value: '4' },
        { text: 'May', value: '5' },
        { text: 'June', value: '6' },
        { text: 'July', value: '7' },
        { text: 'August', value: '8' },
        { text: 'September', value: '9' },
        { text: 'October', value: '10' },
        { text: 'November', value: '11' },
        { text: 'December', value: '12' }
      ],

      years: [
        { text: '2021', value: '2021' },
        { text: '2022', value: '2022' },
        { text: '2023', value: '2023' },
        { text: '2024', value: '2024' },
        { text: '2025', value: '2025' },
        { text: '2026', value: '2026' },
      ],
      weekend_color_code:'',
      holiday_color_code:'',
      show_lg:0,
      leave_color:[],
      leave_titles:[],


    }

  },
  methods:{

    getAttendanceCell(attendance, d, day_details) {
      var row = attendance.attendances_list_by_day[d] || null;

      if (row && row.leave_data) {
        return {
          type: 'leave',
          tooltip: this.getLeaveTooltip(row),
          clickable: false,
          row: row,
        };
      }

      var hasRealAttendance = row && row.id &&
          row.check_in && row.check_in != '00:00:00' && row.check_in != '0' &&
          row.checkout && row.checkout != '00:00:00' && row.checkout != '0';

      if (day_details.day === 'weekend' && !hasRealAttendance) {
        return {
          type: 'weekend',
          tooltip: '',
          clickable: false,
          row: row,
        };
      }

      if (day_details.day === 'holiday' && !hasRealAttendance) {
        return {
          type: 'holiday',
          tooltip: '',
          clickable: false,
          row: row,
        };
      }

      if (!row) {
        return {
          type: 'empty_absent',
          tooltip: '',
          clickable: false,
          row: null,
        };
      }

      if (String(row.off) === '1') {
        return {
          type: 'weekend',
          tooltip: '',
          clickable: false,
          row: row,
        };
      }

      if (row.id) {
        if (
            row.check_in != '00:00:00' &&
            row.check_in != '0' &&
            row.check_in != null &&
            row.checkout != '00:00:00' &&
            row.checkout != '0' &&
            row.checkout != null &&
            row.absent == 0 &&
            row.activity_log != '' &&
            row.activity_log != null &&
            row.late_check_in <= this.grace_time_late_check_in &&
            row.early_checkout <= this.grace_time_early_checkout
        ) {
          return {
            type: 'success',
            tooltip: this.getAttendanceTooltip(row),
            clickable: true,
            row: row,
          };
        }

        if (row.early_checkout > 0) {
          return {
            type: 'early_leave',
            tooltip: this.getAttendanceTooltip(row),
            clickable: true,
            row: row,
          };
        }

        if (row.late_check_in > 0) {
          return {
            type: 'late',
            tooltip: this.getAttendanceTooltip(row),
            clickable: true,
            row: row,
          };
        }

        if (row.absent == 1) {
          return {
            type: 'absent',
            tooltip: row.comment || '',
            clickable: false,
            row: row,
          };
        }

        if (
            (row.check_in == '00:00:00' || row.check_in == '0' || row.check_in == null) &&
            (row.checkout == '00:00:00' || row.checkout == '0' || row.checkout == null) &&
            row.absent != 1
        ) {
          return {
            type: 'resolve_absent',
            tooltip: '',
            clickable: true,
            row: row,
          };
        }
      }

      return {
        type: 'empty_absent',
        tooltip: '',
        clickable: false,
        row: row,
      };
    },
    getAttendanceTooltip(row) {
      var text = '';

      text = this.formateMe(row.check_in) + ' to ' + this.formateMe(row.checkout);

      if (row.comment != '' && row.comment != null) {
        text = text + ' ' + row.comment;
      }

      if (row.auto_checkout == 1) {
        text = text + ' | System Intervened';
      }

      return text;
    },

    getLeaveTooltip(row) {
      if (!row.leave_data) {
        return '';
      }

      var leaveTitle = this.leave_titles[row.leave_data.leave_type_id] || 'On Leave';
      var comment = row.leave_data.comment || '';

      if (comment != '' && comment != null) {
        return leaveTitle + ' ' + comment;
      }

      return leaveTitle;
    },
    getCellClass(cell) {
      if (cell.type === 'weekend') {
        return 'text-info attendance-box';
      }

      if (cell.type === 'holiday') {
        return 'text-success attendance-box';
      }

      if (cell.type === 'leave') {
        return 'cursor-pointer attendance-box leave';
      }

      if (cell.type === 'success') {
        return 'cursor-pointer attendance-box success';
      }

      if (cell.type === 'early_leave') {
        return 'cursor-pointer attendance-box late';
      }

      if (cell.type === 'late') {
        return 'cursor-pointer attendance-box late';
      }

      if (cell.type === 'absent') {
        return 'cursor-pointer attendance-box absent';
      }

      if (cell.type === 'resolve_absent') {
        return 'cursor-pointer attendance-box empty absent';
      }

      return 'cursor-pointer attendance-box empty absent';
    },
    getCellStyle(cell, day_details) {
      if (cell.type === 'weekend') {
        return {
          backgroundColor: this.head_color[day_details.day]
        };
      }

      if (cell.type === 'holiday') {
        return {
          backgroundColor: this.head_color[day_details.day]
        };
      }

      if (cell.type === 'leave' && cell.row && cell.row.leave_data) {
        return {
          backgroundColor: this.leave_color[cell.row.leave_data.leave_type_id]
        };
      }

      return {};
    },
    handleCellClick(cell, attendance, day_details) {
      console.log(cell.type)
      if (cell.type === 'success' || cell.type === 'early_leave' || cell.type === 'late') {
        this.showActivity(cell.row);
        return;
      }

      if (cell.type === 'resolve_absent') {
        this.showResolve(attendance.employee_id, day_details.date);
      }
    },




    setUrls:function()
    {
      this.upload_url = this.$api_url+"/employee/attendance/import";
      this.process_url = this.$api_url+'/front/employee/attendance/import/process';

    },

    uploadFile:function(event)
    {
      if(!this.checkNet()) return false;
      this.showoverlay = true;
      this.errormsg = [];
      // this function upload the logo
      this.empfile = event.target.files[0];

      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      const data = new FormData();
      data.append('empfile', this.empfile);

      axios.post(this.upload_url, data , config).
      then(function (response){

        this.has_file = true;

        this.$bvToast.toast('Processing the data feed file.', {
          title: `Job on progress`,
          variant: 'info',
          solid: true
        });

        this.showoverlay = false;
        this.processFileData();

      }.bind(this)).
      catch(function (error)
      {
        //alert(error.response.data.errors);
      });
    },
    processFileData:function()
    {
      if(!this.checkNet()) return false;
      this.showoverlay = true;
      let currentObj = this;
      this.errormsg = [];
      axios.get(this.process_url)
          .then(function (response) {

            if(response.data.status)
            {
              this.$bvToast.toast('Valid attendance inputs have been successfully imported and invalid inputs have been ignored.', {
                title: `Success`,
                variant: 'success',
                solid: true
              });
              this.$bvModal.hide('bv-modal-import-leave');

              //setTimeout(function () {location.reload();  }.bind(this), 1000);
              this.reloadData();
              this.$bvModal.hide('bv-modal-import-attendance');
            }
            else
            {
              this.errormsg = response.data.errors;
            }

            this.showoverlay = false;

          }.bind(this)).catch(function (error){

        //currentObj.serverError(error);
        currentObj.showoverlay = false;
        currentObj.$bvToast.toast('Please correct the data and try again.', {
          title: `Data Template Error`,
          variant: 'danger',
          solid: true
        });

      }); ;
    },

    // Added by sohel
    importAttendances: function()
    {
      this.$bvModal.show('bv-modal-import-attendance');
    },


    /********************* */
    reloadData: function()
    {
      this.resolve_flg = 0;
      this.$bvModal.hide('edit_Modal');
      this.$bvModal.hide('addLeave_Modal');
      this.$bvModal.hide('workedOffsite_Modal');


      this.getEmployeesAttendanceNew();
    },
    resetdata : function()
    {
      this.attendances_date = null;
      this.check_in = null;
      this.checkout = null;
      this.work_time = 0;
      this.break_time = 0;
      this.over_time = 0;
    },
    convertMinsToHrsMins: function (minutes) {

      /*if(ins.checkout == '00:00:00')
          return '..';*/


      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return h + ':' + m;
    },
    formateMe :function(minutes){

      if(minutes == '00:00:00' || minutes == '0' || minutes == null) return '..';

      return moment(minutes, "hh:mm").format('LT');
    },
    showActivity : function(ins)
    {
      this.resetdata();

      this.attendances_date = moment(String(ins.attendances_date)).format('YYYY-MM-DD ');
      this.check_in = moment(ins.check_in, "hh:mm").format('LT');

      if(ins.checkout != '00:00:00' && ins.checkout != null && ins.checkout != '0')
        this.checkout = moment(ins.checkout, "hh:mm").format('LT');
      else
        this.checkout = '..';

      this.work_time = this.convertMinsToHrsMins(ins.work_time);
      this.break_time = this.convertMinsToHrsMins(ins.break_time);
      this.over_time = this.convertMinsToHrsMins(ins.over_time);

      this.activity_log = ins.activity_log;

      this.$bvModal.show('activity_logModal');

    },
    showResolve : function(employee_id , d)
    {
      // Disabled from ESS by Ali
      return 0;
      this.resetdata();
      this.setEmployee(employee_id);
      this.edit_date = moment(String(d)).format('YYYY-MM-DD');
      this.employee_id = employee_id;
      this.$bvModal.show('edit_Modal');
    },
    addLeave : function()
    {
      //this.employee_id

      this.$bvModal.hide('edit_Modal');
      this.$bvModal.show('addLeave_Modal');


    },
    workedOffsite : function(x)
    {
      this.resolve_flg = x;
      this.$bvModal.hide('edit_Modal');
      this.$bvModal.show('workedOffsite_Modal');
    },
    resolve : function()
    {

    },
    setEmployee(x)
    {
      let currentObj = this;
      let formData = new FormData();
      formData.append('employee_id', x);
      axios.post(this.$api_url+'/front/employee/setemployee', formData)
          .then(function (response)
          {
            return;

          }.bind(this))
          .catch(function (error)
          {
            currentObj.showoverlay = false;
            currentObj.serverError(error);
          });
    },

    getEmployeesAttendanceNew: function()
    {

      if(!this.checkNet()) return false;
      this.getLeaveTypes();
      let currentObj = this;

      var today = new Date();

      let month = this.month;
      let year = this.year;
      // let fiscal_year = this.f_y;
      // let years = fiscal_year.split('-');

      // //if ((today.getMonth() + 1) <= 6) year = years[0];
      // if (month <= 6) year = years[1];
      // else year = years[0];

      // this.year = year;



      // if((today.getFullYear() == year) && (month > (today.getMonth() + 1)))
      // {
      //   this.can_download_template = false;

      //   this.month = (today.getMonth() + 1);

      //   currentObj.$bvToast.toast("Future date can't be accessed!", {
      //     title: `Warning`,
      //     variant: 'warning',
      //     solid: true
      //   });

      //   return false;
      // }
      // else
      // {
      //   this.can_download_template = true;;
      // }


      axios.get(this.$api_url+'/front/employee/attendance/month?approver=1' , {
        params: {
          month: month,
          year: year,
          export_flg : 0,
        }
      }).then(function(response){
        this.attendances = response.data.attendances_list;

        if(this.attendances.length == 0)
          this.blankmsg = "Looks like you have not added any employee attendance yet for the selected month.";


        this.week_days_header = response.data.week_days_header;
        this.head_color = response.data.head_color;

        this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 500, text: "500" },
          { value: this.attendances.length, text: "All" }
        ];
        this.people = this.attendances.length;

        this.today_index = response.data.today_index;

        this.grace_time_late_check_in = response.data.grace_time_late_check_in;
        this.grace_time_early_checkout = response.data.grace_time_early_checkout;



      }.bind(this)).catch(function (error){ currentObj.serverError(error);});
    },

    getEmployeesAttendance: function()
    {

      if(!this.checkNet()) return false;
      this.getLeaveTypes();
      let currentObj = this;

      var today = new Date();

      let month = this.month;
      let year = this.year;
      let fiscal_year = this.getCurrentFinancialYear();
      this.f_y = this.getCurrentFinancialYear();
      let years = fiscal_year.split('-');

      //if ((today.getMonth() + 1) <= 6) year = years[0];
      if (month <= 6) year = years[1];
      else year = years[0];

      this.year = year;



      // if((today.getFullYear() == year) && (month > (today.getMonth() + 1)))
      // {
      //   this.can_download_template = false;

      //   this.month = (today.getMonth() + 1);

      //   currentObj.$bvToast.toast("Future date can't be accessed!", {
      //     title: `Warning`,
      //     variant: 'warning',
      //     solid: true
      //   });

      //   return false;
      // }
      // else
      // {
      //   this.can_download_template = true;;
      // }


      axios.get(this.$api_url+'/front/employee/attendance/month?approver=1' , {
        params: {
          month: month,
          year: year,
          export_flg : 0,
        }
      }).then(function(response){
        this.attendances = response.data.attendances_list;

        if(this.attendances.length == 0)
          this.blankmsg = "Looks like you have not added any employee attendance yet for the selected month.";


        this.week_days_header = response.data.week_days_header;
        this.head_color = response.data.head_color;

        this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 500, text: "500" },
          { value: this.attendances.length, text: "All" }
        ];
        this.people = this.attendances.length;

        this.today_index = response.data.today_index;

        this.grace_time_late_check_in = response.data.grace_time_late_check_in;
        this.grace_time_early_checkout = response.data.grace_time_early_checkout;



        let currentObj = this;


        let st_date = new Date(year , month-2 , 1);
        let en_date = new Date(year , month , 0);

        this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
        this.end_date = moment(String(en_date)).format('Do MMMM YYYY');


        // fetch holidays dynamically from controller
        axios.get(this.$api_url+'/front/employee/attendances/details' , {
          params: {
            st_date: this.start_date,
            en_date: this.end_date,
          }
        }).then(function(response){


          this.weekend_color_code = response.data.report.weekend_color_code;
          this.holiday_color_code = response.data.report.holiday_color_code;
          currentObj.show_lg = 1;
          //this.$refs.trzcalendar;


        }.bind(this)).catch(function (error){ currentObj.serverError(error);});





      }.bind(this)).catch(function (error){ currentObj.serverError(error);});
    },
    setFirstPage :  function()
    {
      this.pagination.currentPage = 1;
      this.length = this.temp_length;
    },

    downloadData : function()
    {
      if(this.attendances.length > 0)
      {
        if(!this.checkNet()) return false;
        let currentObj = this;
        axios.get(this.$api_url+'/front/employee/attendance/month?approver=1' , {
          params: {
            month: this.month,
            year: this.year,
            export_flg : 1,
          }
        }).then(function(response){
          //this.attendances = response.data.attendances_list;

          if(response.data.attendances_list == 0)
            this.blankmsg = "Looks like you have not added any employee attendance yet.";

        }.bind(this)).catch(function (error){ currentObj.serverError(error);});
      }
    },
    getLeaveTypes: function()
    {
      if(!this.checkNet()) return false;

      axios.get(this.$api_url+'/front/leave/types' , {
        params: {

        }
      }).then(function(response){

        this.leavetypes = response.data;
        this.leavetypes.forEach(obj => {
          this.leave_color[obj.id] = obj.color_code;
          this.leave_titles[obj.id] = obj.title;

        });

      }.bind(this));
    },


  },
  created: function(){

    this.getEmployeesAttendance();
    this.setUrls();


  },
  computed:
      {
        filteredData()
        {
          let filtered_list = this.attendances;
          if (this.search)
          {
            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
          }
          return filtered_list;
        },
        paginatedData()
        {
          return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },


      }
}
</script>
<style scoped>

.table-sticky{
  position: relative;
}
.table-sticky thead td {

  position: sticky;
  top: 0;
  background: #CCF4FE;
  z-index: 9;
}
.table-parent{
  height: 100vh;
  overflow: auto;

}
.custom-search .attendance-search {
  border: 1px solid #efefef;
  border-radius: 7px;
}
</style>
